import { render, staticRenderFns } from "./CourseSelect.vue?vue&type=template&id=432faf38&scoped=true&"
import script from "./CourseSelect.vue?vue&type=script&lang=js&"
export * from "./CourseSelect.vue?vue&type=script&lang=js&"
import style0 from "./CourseSelect.vue?vue&type=style&index=0&id=432faf38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432faf38",
  null
  
)

export default component.exports